import {
  Component, Injector, Input,
  OnChanges,
  SimpleChanges,
  ViewChild,
  inject
} from '@angular/core';

import { IMAGES_URL, MEMBERSHIP_TYPE_COMBINATIONS, MEMBERSHIP_TYPES, MembershipType } from '@src/app/core/constants/system-list.constant';
import { MembershipModalComponent } from '../membership-modal/membership-modal.component';
import { CoreClass } from '@src/app/core/base/core.class';
import { GET_MEMBERSHIPS, SERVER_URL } from '@src/app/core/constants';
import { elementAt, firstValueFrom, takeUntil } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { NgxUiLoaderService } from "ngx-ui-loader";


@Component({
  selector: 'app-membership-plan',
  templateUrl: './membership-plan.component.html',
  styleUrls: ['./membership-plan.component.scss'],
  standalone: false
})

export class MembershipPlanComponent extends CoreClass implements OnChanges {
  @Input() image: string = '';
  @Input() imageStyle: string = '';
  @Input() label: string | null = '';
  @Input() note1: string | null = '';
  @Input() note2: string | null = '';
  @Input() note3: string | null = '';
  @Input() btnLabel: string | null = '';
  @Input() changePlan: boolean = false;
  @Input() membershipPlanCode: string | null = '';
  @Input() membershipCode: string | null = '';
  @Input() membershipDentalCode: string | null = '';
  @Input() hideFrequency = false;
  @Input() isDiscounted = false;
  @Input() selectedPackage = 'Basic';
  @Input() hideAnnualDiscount = false;
  @ViewChild(MembershipModalComponent)
  modalComponent!: MembershipModalComponent;
  IMAGES_URL: string = IMAGES_URL;
  ngxService = inject(NgxUiLoaderService)

  showTooltip = false;
  offers: any = [];
  pricingType = 'monthly';
  planFor: MembershipType = 'Individual';
  selectedPlanForLabel = 'Individual';
  selectedMembership: any;
  membershipTypeForParam = MEMBERSHIP_TYPES.ADDON_DEFAULT;

  freeServices: any[] = [];
  services: any[] = [];
  membershipOptions: any[] = [];
  isLoading = false;
  comprehensiveMembershipIds: any[] = [];
  discountAmount = 0;


  optionA_Offers = [
    { name: 'Doctor’s office visits - up to 35% off', active: true },
    { name: 'Lab tests - up to 75% off', active: true },
    { name: 'Imaging Centers - up to 70% off', active: true },
    { name: 'Procedures and Surgeries - up to 50% off', active: false },
    { name: 'Dental & Vision - up to 60% off', active: false },
    { name: 'Preventive services - One office visit, Mammogram, etc.', active: false },
    { name: 'Hospitalizations & ER visits - $2500 out-of-pocket per need', active: false },
  ]
  optionB_Offers = [
    { name: 'Doctor’s office visits - up to 35% off', active: true },
    { name: 'Lab tests - up to 75% off', active: true },
    { name: 'Imaging Centers - up to 70% off', active: true },
    { name: 'Procedures and Surgeries - up to 50% off', active: true },
    { name: 'Dental & Vision - up to 60% off', active: true },
    { name: 'Preventive services - One office visit, Mammogram, etc.', active: false },
    { name: 'Hospitalizations & ER visits - $2500 out-of-pocket per need', active: false },
  ]
  optionC_Offers = [
    { name: 'Doctor’s office visits - up to 35% off', active: true },
    { name: 'Lab tests - up to 75% off', active: true },
    { name: 'Imaging Centers - up to 70% off', active: true },
    { name: 'Procedures and Surgeries - up to 50% off', active: true },
    { name: 'Dental & Vision - up to 60% off', active: true },
    { name: 'Preventive services - One office visit, Mammogram, etc.', active: true },
    { name: 'Hospitalizations & ER visits - $2500 out-of-pocket per need', active: true },
  ]
  memberships: any[] = [];
  monthlyMemberships: any[] = [];
  yearlyMemberships: any[] = [];
  serviceIds: any[] = [];
  pricingList: any[] = [];
  noOfChildren = 0;
  tempMemberships: any;
  showCurrent = false;
  currentMembership: any;
  hasDentalVision = false;
  hasReducePrimaryCare = false;
  showAddOns = true;

  constructor(
    injector: Injector,
    private route: ActivatedRoute
  ) {
    super(injector);
  }
  ngAfterViewInit() {
    // Give Angular time to render the view
    setTimeout(() => {
      this.route.fragment.subscribe(fragment => {
        if (fragment) {
          const el = document.getElementById(fragment);
          if (el) {
            el.scrollIntoView({ behavior: 'smooth' });
          }
        }
      });
    }, 100); // Delay to ensure DOM is rendered
  }
  async ngOnInit() {
   
    this.offers = this.optionA_Offers;
    // Set pricing type from params (if available)
    const frequency = await this.route.snapshot.queryParamMap.get('frequency');
    this.pricingType = frequency || this.pricingType;
    
    
    this.membershipTypeForParam = this.membershipPlanCode || this.membershipTypeForParam;
    // Get membership listing
    await this.getMembershipsList();

    if (window.location.pathname == '/change-plan') {
      this.showCurrent = true;
      let membership = JSON.parse(localStorage.getItem('membershipToChangeDetails') as any);
      
      
      
      const targetName = (membership?.membershipName || '').trim().toLowerCase();

      // Match the current plan robustly: exact (normalized) first, then a
      // contains match to tolerate brand/suffix differences in mini-env lists.
      this.currentMembership =
        this.memberships.find(x => (x.name || '').trim().toLowerCase() === targetName) ||
        this.memberships.find(x => targetName && (x.name || '').trim().toLowerCase().includes(targetName));

      if (this.currentMembership) {
        this.selectPackage(this.currentMembership);
      } else {
        // Current plan isn't part of this (mini-env filtered) list — fall back
        // to the first available plan instead of leaving a stale selection.
        this.selectPackage(this.memberships[0]);
      }
    }

    this.setMiniEnvSettings();
    // this.pricingType = obj.pricingType;
    // this.selectedPlanForLabel = obj.planLabel;
    // this.selectedPackage = obj.title;

  }

  ngOnChanges(changes: SimpleChanges): void {
    this.membershipTypeForParam = this.membershipPlanCode || this.membershipTypeForParam;
  }

  //  getMemberships() {

  //   this.isLoading = true;
  //   let endpoint = SERVER_URL + `/membership/get-wow-memberships?code=${MEMBERSHIP_PARAMS}`;

  //   this.httpService.requestEntity('GET', endpoint, null, undefined, false)
  //   .pipe(takeUntil(this.onDestroy$))
  //   .subscribe((res)=> {
  //      let response = res.body;
  //      if (response.data) {

  //       let memberships = response.data;
  //       this.tempMemberships = response.data;

  //       this.serviceIds = memberships.map((x: any) => x.fkServiceId);

  //       this.getPricing(memberships);

  //      }

  //      console.log(this.memberships);
  //      console.log(this.services);
  //      console.log(this.freeServices);


  //   });
  // }

  async getMembershipsList() {
    this.isLoading = true;
     this.ngxService.start();

    let membershipCode = this.getMembershipCode();

    const queryParams = {
      ...(membershipCode ? { membershipCode: [membershipCode] } : {membershipType: this.membershipTypeForParam.split(',')}),
      variants: { PLAN_TYPE: this.planFor },
      noOfChild: this.noOfChildren,
      frequency: this.pricingType.toUpperCase()
    };

    const config = this.storageService.getMiniEnvConfig();    
    this.discountAmount = this.isDiscounted ? config.discountAmount : 0;

    const res = await firstValueFrom(
        (await this.apiService.getMembershipPlans(queryParams))
          .pipe(takeUntil(this.onDestroy$))
      );

      if (res.data) {

        this.memberships = res.data;
        // Map to track counts of duplicate names
        const nameCount: Record<string, number> = {};
        

        this.memberships.forEach((element: any, index) => {
          // if this name appeared before, increment counter, else start at 0
          if (nameCount[element.name] !== undefined) {
            nameCount[element.name]++;
          } else {
            nameCount[element.name] = 0;
          }

          // attach a sequence index for this name
          element.nameIndex = nameCount[element.name];

          // build a unique identifier (name + index)
          element.identifier = `${element.name}-${element.nameIndex}`;
          element.isComprehensive = element.name.includes('Comprehensive') ;
          // Get services from first element
          if (index === 0) {
            this.freeServices = element.packageDetails.filter((x: any) => x.group == 1);
            this.services = element.packageDetails.filter((x: any) => x.group == 2);
            // this.pricingType = element.description.includes('Monthly') ? 'monthly' : 'yearly';
          }

          //Set key if includes Dental and Vision
          element['hasDentalAndVision'] = element.packageDetails.some((x: any) => x.title == 'Dental & Vision' && x.available);       


          //Set key for discounted prices
          if (config && config.discountAmount && this.isDiscounted) {
            element['discountPrice'] = (element.price - config.discountAmount) <= 0 ? 'Free': (element.price - config.discountAmount).toFixed(2);
          }

          // Update the already selected membership on type change
          if (this.selectedMembership && this.selectedMembership.identifier === element.identifier) {
            this.selectPackage(element);
          }
          // If queryparam has a selected package flag
          if (this.selectedPackage){
            const selectedPackage = this.selectedPackage.toLowerCase();
            const membershipname = element.name.toLowerCase();
            if (membershipname.includes(selectedPackage) && element.price != 0) {
              this.selectPackage(element);
            }
            
          }

          
          element['footerDesc'] = element.planFooterDetails[0]?.label || '';
        });
             

        //If Exclude Basic Flag is true in MiniEnv, then remove basic from list.
        if (this.storageService.getMiniEnvConfig() && this.storageService.getMiniEnvConfig().basicExcluded) {
          const index = this.memberships?.indexOf(this.memberships.find(x => x.name == 'Basic')) ?? -1;
          if (index !== -1) {
            this.memberships.splice(index, 1);
          }
        }

        //Preselect the first membership on page load
        if (!this.selectedMembership) {
          this.selectedMembership = this.memberships[0];
        } 

        //Hide DentalVision Add Ons if selected membership is Dental & Vision
        // this.showAddOns = !this.memberships.some(x=> x.name.toLowerCase().includes('dental'));
        this.showAddOns = !this.selectedMembership?.name.toLowerCase().includes('dental');

        this.isLoading = false;
        this.ngxService.stop();
      }
  }

  getPricing(memberships: any) {
    let endpoint = SERVER_URL + `/service/get-variant-price`;
    let data = { serviceIds: this.serviceIds, planType: this.planFor, variants: [] }

    this.httpService.requestEntity('POST', endpoint, data, undefined, false)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((res) => {
        let response = res.body;
        this.pricingList = response.data;

        memberships.forEach((element: any) => {

          if (typeof (element.packageData) == 'string') {
            element.packageData = JSON.parse(element.packageData);
          }

          // if (element.code == 'COMPREHENSIVE_CARE_MONTHLY' || element.code == 'COMPREHENSIVE_CARE_YEARLY') {
          //   this.comprehensiveMembershipIds.push(element.fkServiceId);
          // }


          this.pricingList.forEach((pricing) => {
            if (element.fkServiceId == pricing.serviceId) {
              element['price'] = pricing.price;
              // Calculate 20% of price and add to it
              const twentyPercentOfPrice = (pricing.price * 20) / 100;
              element['originalPrice'] = (pricing.price + twentyPercentOfPrice).toFixed(2);
            }
          })
        });

        this.monthlyMemberships = memberships.filter((x: any) => x.renewalFrequency == 'MONTHLY');
        this.yearlyMemberships = memberships.filter((x: any) => x.renewalFrequency == 'YEARLY');
        let x;

        this.monthlyMemberships.forEach((element: any, index) => {
          // Get services from first element
          if (index == 0) {
            this.freeServices = element.packageData.filter((x: any) => x.group == 1);
            this.services = element.packageData.filter((x: any) => x.group == 2);
          }
        });

        // this.monthlyMemberships.forEach((element, index)=> {
        //    this.pricingList.forEach((pricing)=> {
        //     if (element.fkServiceId == pricing.serviceId) {
        //       element['price'] = pricing.price;
        //     }
        //    })
        // })
        // Show monthly memberships by default
        this.memberships = this.monthlyMemberships;
        this.selectedMembership = this.monthlyMemberships[0];
        this.isLoading = false;
        this.ngxService.stop();


        // If plan is already selected and user landed on Change plan Screen

        // let alreadySelectedPlan = JSON.parse(localStorage.getItem('planData') as any);

        // if (alreadySelectedPlan && this.changePlan) {

        //   this.pricingType = alreadySelectedPlan.pricingType;
        //   this.selectedPlanForLabel = alreadySelectedPlan.planLabel;
        //   this.selectedPackage = alreadySelectedPlan.title;
        //   this.noOfChildren = alreadySelectedPlan.noOfChildren;

        //   this.memberships = this.pricingType == 'yearly' ? this.yearlyMemberships: this.monthlyMemberships;

        //   this.selectedMembership = this.memberships.find(x=> x.title == alreadySelectedPlan.title);
        //   this.freeServices = this.selectedMembership.packageData.filter((x:any)=> x.group == 1);
        //   this.services = this.selectedMembership.packageData.filter((x:any)=> x.group == 2);
        // }

      });
  }

  selectPackage(membership: any) {

    if (!membership) {
      return;
    }

    this.selectedMembership = membership;
    this.selectedPackage = membership.name;

    this.freeServices = (membership.packageDetails || []).filter((x: any) => x.group == 1);
    this.services = (membership.packageDetails || []).filter((x: any) => x.group == 2);
    this.showAddOns = !this.selectedMembership?.name.toLowerCase().includes('dental');

  }

  setPricingType(type: string) {
    this.pricingType = type;
    // if (this.storageService.getMiniEnvConfig()) {
    //   this.setMembershipCode();
    // }
    this.getMembershipsList();
    // if (type == 'yearly') {
    //   this.yearlyMemberships.forEach((element: any, index) => {
    //     if (index == 0) {
    //       this.freeServices = element.packageData.filter((x: any) => x.group == 1);
    //       this.services = element.packageData.filter((x: any) => x.group == 2);
    //     }
    //   });
    //   this.memberships = this.yearlyMemberships;
    // } else {
    //   this.monthlyMemberships.forEach((element: any, index) => {
    //     if (index == 0) {
    //       this.freeServices = element.packageData.filter((x: any) => x.group == 1);
    //       this.services = element.packageData.filter((x: any) => x.group == 2);
    //     }
    //   });
    //   this.memberships = this.monthlyMemberships;
    // }
  }

  open() {
    this.modalComponent.open();
  }

  getModalData(event: any) {
    this.selectedPlanForLabel = event.preference;
    this.planFor = event.planType;
    this.noOfChildren = event.childCount;
    localStorage.setItem('membershipData', JSON.stringify(event));

    //  if (localStorage.getItem('planData')) {
    //   JSON.parse(localStorage.getItem('planData') as any).noOfChildren = this.noOfChildren;
    //  }

    //  this.getPricing(this.tempMemberships);
    this.getMembershipsList();
  }

  updateMembershipTypeOnChange() {

    const combo = this.getMembershipCombination(this.membershipTypeForParam);

    if (combo) {
      this.membershipTypeForParam = this.hasDentalVision
        ? combo.dental
        : combo.default;
    }
    
    // let defaultTypes = MEMBERSHIP_TYPES.ADDON_DEFAULT.split(',');
    // let dentalTypes = MEMBERSHIP_TYPES.ADDON_DENTAL;

    // if (this.hasDentalVision) {
    //   if (!this.membershipTypeForParam?.includes(',')){
    //     if (this.membershipTypeForParam == defaultTypes[0]) {
    //       this.membershipTypeForParam = MEMBERSHIP_TYPES.DENTAL_PLUS_ONLY;
    //     } else {
    //       this.membershipTypeForParam = MEMBERSHIP_TYPES.DENTAL_COMPREHENSIVE_ONLY;
    //     }
    //   } else {
    //     this.membershipTypeForParam = MEMBERSHIP_TYPES.ADDON_DENTAL;
    //   }
    // } 
    // else {
    //   if (!this.membershipTypeForParam?.includes(',')) {

    //       if (this.membershipTypeForParam == dentalTypes[0]) {
    //         this.membershipTypeForParam = defaultTypes[0];
    //       } else {
    //         this.membershipTypeForParam = defaultTypes[1];
    //       }
    // } else {
    //   if (this.storageService.getMiniEnvConfig()) {
    //     this.setMiniEnvPlanTypes();
    //   } else {
    //     this.membershipTypeForParam =
    //       MEMBERSHIP_TYPES.ADDON_DEFAULT;
    //   }
    // }
    // }


    // if (this.hasDentalVision && this.hasReducePrimaryCare) {
    //   this.membershipTypeForParam = MEMBERSHIP_TYPES.DUAL_ADDONS;
    // } 
    // else {      
      // if (this.hasDentalVision && !this.hasReducePrimaryCare) {
      //   this.membershipTypeForParam = MEMBERSHIP_TYPES.ADDON_DENTAL;
      // } else if (!this.hasDentalVision && this.hasReducePrimaryCare) {
      //   this.membershipTypeForParam = MEMBERSHIP_TYPES.ADDON_REDUCE_INPERSON;
      // } else {
      //   this.membershipTypeForParam = MEMBERSHIP_TYPES.ADDON_DEFAULT;
      // }

    // }
    this.selectedMembership = null;
    this.getMembershipsList();
  }

  goToPayment() {

    let data = {
      "title": this.selectedMembership.name,
      "pricingType": this.pricingType,
      "planFor": this.planFor,
      "planLabel": this.selectedPlanForLabel,
      "noOfChildren": this.noOfChildren,
      "price": this.selectedMembership.price,
      "membershipId": this.selectedMembership.id,
      ...(this.membershipCode ? { membershipCode: [this.membershipCode] } : {membershipType: this.membershipTypeForParam.split(',')}),
    };
    
    
    let addToCartPayload =
    {
      "serviceID": this.selectedMembership.service.id,
      "patientID": this.storageService.getUserInformation() ? this.storageService.getUserInformation().userAccountId : 0,
      "membershipID": this.selectedMembership.id,
      "variants": { PLAN_TYPE: this.planFor }
    }
    this.storageService.setPlanData(data)

    if (!this.changePlan) {

      // localStorage.setItem('addToCartData', JSON.stringify(addToCartPayload));
      this.storageService.setAddToCartData(addToCartPayload)
      if (this.selectedPackage == 'Comprehensive') {
        this.router.navigateByUrl('healthshare-selection');
        // window.location.href = '/healthshare-selection';
      } else {
        this.sharedService.addToCart();
      }

    } else {

      let data = {
        "pricingType": this.pricingType,
        "planFor": this.planFor,
        "title": this.selectedMembership.name,
        "membershipId": this.selectedMembership.id
      }

      if (this.selectedPackage != 'Comprehensive') {
        localStorage.setItem('selectedMembershipForUpgrade', JSON.stringify(data));
      }

      if (this.selectedPackage == 'Comprehensive') {
        this.router.navigateByUrl('healthshare-selection?change-plan=true');
      }
      else {
        //  localStorage.setItem('membershipToUpdateId', this.selectedMembership.fkServiceId);
        this.router.navigateByUrl(`/profile-completion/${this.storageService.getMembershipSubscriptionId()}?changePlan=true`);
      }

    }


    // else {
    //   this.sharedService.addToCart();
    //   }

  }

  setMiniEnvPlanTypes() {
     const config = this.storageService.getMiniEnvConfig();
      if (config.membershipPlanTypes) {
          this.membershipTypeForParam = config.membershipPlanTypes;
      }
  }

  getMembershipCode() {

    const isMonthly = String(this.pricingType).toLowerCase() === 'monthly';
    let membershipCode = '';
    let membershipDentalCode = '';

    if (this.membershipCode) {
        membershipCode = this.membershipCode;

        if (this.membershipCode.includes(',')) {
          const parts = this.membershipCode.split(',');
          membershipCode = isMonthly ? parts[0] : parts[1];
        }
    }

    if (this.membershipDentalCode) {
        membershipDentalCode = this.membershipDentalCode;
        if (this.membershipDentalCode && this.membershipDentalCode.includes(',')) {
            const parts = this.membershipDentalCode.split(',');
            membershipDentalCode = isMonthly ? parts[0] : parts[1];
        }
    }

    return this.hasDentalVision ? membershipDentalCode : membershipCode;

  }

getMembershipCombination(type: string) {
 
  if (this.storageService.getMiniEnvConfig()) {

    const id = this.storageService.getMiniEnvConfig().config_id;
    if (id == 'iac') {
      const type: any = MEMBERSHIP_TYPE_COMBINATIONS.find(x=> x.default == MEMBERSHIP_TYPES.ADDON_DEFAULT && x.dental == MEMBERSHIP_TYPES.ADDON_DENTAL)
      
      
      
      if (type) {
        MEMBERSHIP_TYPE_COMBINATIONS.splice(MEMBERSHIP_TYPE_COMBINATIONS.indexOf(type),1);
      }
    }
  }

  return MEMBERSHIP_TYPE_COMBINATIONS.find(
    combo =>
      combo.default === type ||
      combo.dental === type
  );
}

  setMiniEnvSettings() {
    const config = this.storageService.getMiniEnvConfig();
    if (config) {
      switch (config.name) {
        case 'Prestige':
          // this.showAddOns = false;
          break;
      }
    }
  }

  // getDiscountedPrice(price: any) {
  //   const config = this.storageService.getMiniEnvConfig();    
  //   let discountPrice = (price - config.discountAmount) <= 0 ? 'Free': (price - config.discountAmount).toFixed(2);
  //   return discountPrice;
  // }




}
